import React from "react";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { useNavigate, Link } from "react-router-dom";
import AnimatedPage from "../AnimatedPage";
import "animate.css/animate.min.css";
import _ from "lodash";
import "../App.css";

function Spelningar({ itemsProp, showOverlay }) {
  const [view, setView] = useState(null);
  const [viewVideo, setViewVideo] = useState(null);
  const [timer, setTimer] = useState("");
  const [isMobile, setIsMobile] = useState("");
  const [showMusic, setshowMusic] = useState(false);
  const [textBrollop, setTextBrollop] = useState(false);
  const [textDop, setTextDop] = useState(false);
  const [textBegravning, setTextBegravning] = useState(false);
  const [showCitat, setShowCitat] = useState("");
  const [pictureTextToShow, setPictureTextToShow] = useState("");
  const [citat, setCitat] = useState([]);
  const [musicCategory, setMusicCategory] = useState("Bröllop");
  const [music, setMusic] = useState([]);
  const [musicFilter, setMusicFilter] = useState([]);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [playingItem, setPlayingItem] = useState("");
  const audioRef = useRef(null);
  const [currentAudioId, setCurrentAudioId] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const formatTime = (time) => {
  if (!time || isNaN(time)) return "0:00";
  const m = Math.floor(time / 60);
  const s = Math.floor(time % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
  };

  const handleFullscreenChange = () => {
    const isFullscreen =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    if (
      !isFullscreen &&
      focusedIndex !== null &&
      videoRefs.current[focusedIndex]
    ) {
      const el = videoRefs.current[focusedIndex];
      const rect = el.getBoundingClientRect();

      const offset = isMobile ? -500 : -100;

      const scrollTop = window.scrollY + rect.top + offset;

      window.scrollTo({ top: scrollTop, behavior: "auto" });
    }
  };

  useEffect(() => {
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
    };
  }, [focusedIndex]);

  const videoRefs = useRef([]);
  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

  const handleVideoClick = (index) => {
    const clickedVideo = videoRefs.current[index];

    if (currentPlayingIndex !== null && currentPlayingIndex !== index) {
      const currentlyPlayingVideo = videoRefs.current[currentPlayingIndex];
      if (currentlyPlayingVideo) {
        currentlyPlayingVideo.pause();
        currentlyPlayingVideo.currentTime = 0;
      }
    }

    if (clickedVideo) {
      clickedVideo.muted = false;
      clickedVideo.play();
      setCurrentPlayingIndex(index);
      setFocusedIndex(index);
    }
  };

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25, // how much of the video must be visible (25%)
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const index = parseInt(entry.target.dataset.index);

        if (!entry.isIntersecting && currentPlayingIndex === index) {
          const video = videoRefs.current[index];
          if (video && !video.paused) {
            video.pause();
            video.currentTime = 0;
            setCurrentPlayingIndex(null);
            setFocusedIndex(null);
          }
        }
      });
    }, observerOptions);

    videoRefs.current.forEach((video, index) => {
      if (video) {
        video.dataset.index = index;
        observer.observe(video);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [currentPlayingIndex]);

  function handleListMusic(item) {
  if (playingItem === item._id) {
    setPlayingItem("");
  } else {
    setPlayingItem(item._id);
  }

  if (currentAudioId === item._id && audioRef.current) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    setCurrentAudioId(null);
    setIsPlaying(false);
    return;
  }

  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  }

  let src = null;
  if (item.filename) {
    src = `https://ellinornielsen-backend.onrender.com/api/uploads/${item.filename}`;
  } else if (item.link) {
    src = item.link;
  }
  if (!src) return;

  if (!audioRef.current) {
    audioRef.current = new Audio();
  }

  audioRef.current.src = src;

  audioRef.current.onloadedmetadata = () => {
    setDuration(audioRef.current.duration);
  };

  audioRef.current.ontimeupdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  audioRef.current.onended = () => {
    setCurrentAudioId(null);
    setIsPlaying(false);
    setCurrentTime(0);
  };

  audioRef.current.play();
  setIsPlaying(true);
  setCurrentAudioId(item._id);
  }

  const history = useNavigate();

  function handleReset() {
    setViewVideo(null);
    return setView(null);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.innerWidth <= 1000) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
    handleResize();
    handleTimer();
    getCitat();
    getMusicText();
  }, []);

  let element = document.querySelector(".bosse");

  if (element) {
    element.remove();
  }

  async function getCitat() {
    const { data } = await axios.get(
      "https://ellinornielsen-backend.onrender.com/api/citat"
    );
    setCitat(data);
  }

  async function getMusicText() {
    const { data } = await axios.get(
      "https://ellinornielsen-backend.onrender.com/api/musictext"
    );
    setMusic(data);
  }

  function handleMusicList(e) {
    setMusicCategory(e);
    const data = music.filter((m) => m.category == e);
    return setMusicFilter(data);
  }

  function closeMenu() {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    setPlayingItem("");
    setCurrentAudioId(null);
    setIsPlaying(false);
    setCurrentTime(0);

    setshowMusic(false);
  }

  function listSelected(type) {
    setView(null);
    setViewVideo(null);

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    setPlayingItem("");
    setCurrentAudioId(null);
    setIsPlaying(false);
    setCurrentTime(0);

    setshowMusic(true);
    if (type === "Bröllop") {
      setTextBrollop(true);
      setTextDop(false);
      setTextBegravning(false);
      return handleMusicList("Bröllop");
    }

    if (type === "Dop") {
      setTextDop(true);
      setTextBrollop(false);
      setTextBegravning(false);
      return handleMusicList("Dop");
    }

    if (type === "Begravning") {
      setTextBegravning(true);
      setTextBrollop(false);
      setTextDop(false);
      return handleMusicList("Begravning");
    }
  }

  function handleResize() {
    if (window.screen.width < 1200) {
      return setIsMobile(true);
    } else {
      return setIsMobile(false);
    }
  }

  function handleTimer() {
    const interval = setInterval(() => {
      return setTimer(true);
    }, 2100);
  }

  function getTextForPicture(img) {
    if (img.text != "null") {
      return setPictureTextToShow(img.text);
    } else {
      setPictureTextToShow("");
    }
  }

  function handleReset() {
    setViewVideo(null);
    setPictureTextToShow(null);
    return setView(null);
  }

  function totalReset() {
    if (view) {
      return setView(null);
    }
  }

  if (showOverlay) return <Total />;

  return (
    <Total onClick={() => totalReset()}>
      <Container2>
            <Sidemenu>
              <div className="menu" onClick={() => listSelected("Bröllop")}>
                <p>
                  Har du svårt att välja låt till <br />
                  en tillställning och behöver <br />
                  inspiration? Klicka
                  <button className="låtförslag">Här</button>
                </p>
              </div>
            </Sidemenu>

            {isMobile && !view && !viewVideo && (
              <SideMenuMobile>
                <button onClick={() => listSelected("Bröllop")}>
                  Låtförslag
                </button>
              </SideMenuMobile>
            )}

            {!isMobile && (
              <Social>
                <div className="content">
                  <Link to="/om" className="link">
                    <div className="card">
                      <div className="icon"></div>
                      <p className="title">Om mig</p>
                      <p className="text"></p>
                    </div>
                  </Link>

                  <Link to="/bokning" className="link">
                    <div className="card">
                      <div className="icon"></div>
                      <p className="title">Bokning</p>
                      <p className="text"></p>
                    </div>
                  </Link>
                </div>
              </Social>
            )}
            {isMobile && (
              <Social>
                <div className="content">
                  <Link to="/om" className="link">
                    <div className="card">
                      <div className="icon"></div>
                      <p className="title">Om mig</p>
                      <p className="text">
                        Klicka här för att läsa mer om mig.
                      </p>
                    </div>
                  </Link>

                  <Link to="/bokning" className="link">
                    <div className="card">
                      <div className="icon"></div>
                      <p className="title">Bokning</p>
                      <p className="text"></p>
                    </div>
                  </Link>
                </div>
              </Social>
            )}
            {view && !showMusic && (
              <Selected2>
                <button onClick={() => handleReset()}>X</button>
                {view && <img onClick={() => handleReset()} src={view} />}
              </Selected2>
            )}

            {viewVideo && !showMusic && (
              <Selected>
                <button onClick={() => handleReset()}>X</button>
                {viewVideo && (
                  <video width="800px" height="64%" controls="controls">
                    <source src={viewVideo} type="video/mp4" />
                  </video>
                )}
                {viewVideo && pictureTextToShow && <p>{pictureTextToShow}</p>}
              </Selected>
            )}

            {showMusic && (
              <div>
                <div className="music-panel">
                <div className="song-options">
                  <button
                    className={
                      textBrollop ? "button-bröllop-active" : "button-bröllop"
                    }
                    onClick={() => listSelected("Bröllop")}
                  >
                    Bröllop
                  </button>
                  <button
                    className={textDop ? "button-dop-active" : "button-dop"}
                    onClick={() => listSelected("Dop")}
                  >
                    Dop
                  </button>
                  <button
                    className={
                      textBegravning
                        ? "button-begravning-active"
                        : "button-begravning"
                    }
                    onClick={() => listSelected("Begravning")}
                  >
                    Begravning
                  </button>

                  <button className="button-close" onClick={() => closeMenu()}>
                    X
                  </button>
                </div>
                <LåtLista>
                  {musicFilter.map((m, index) => (
                    <div key={index} className="list-container">
                      <div>
                      <p className="låt">{`${m?.song}`}</p>
                      <p className="artist">- {`${m?.artist}`}</p>
                      </div>
                      {m.link && !m.filename && (
                          <img
                            src="stop-icon.png"
                            className="list-button"
                            alt="Play"
                            style={{ filter: "invert(0) grayscale(100%) brightness(0)", position: "absolute", right: "0px", cursor: "pointer" }}
                          />
                      )}
                      {m.filename && (
                          <img
                            src={playingItem === m._id ? "stop-icon.png" : "play-icon.png"}
                            className="list-button"
                            alt={playingItem === m._id ? "Stop" : "Play"}
                            style={{ filter: "invert(0) grayscale(100%) brightness(0)", position: "absolute", right: "0px", cursor: "pointer" }}
                            onClick={() => handleListMusic(m)}
                          />
                      )}
                    </div>
                  ))}
                </LåtLista>
                {playingItem && (
                <MediaPlayer>
                  {(() => {
                    const current = musicFilter.find((m) => m._id === playingItem);
                    if (!current) return null;

                    return (
                      <div style={{ width: "100%" }}>
                        <div className="text">
                          <span className="song-name">{current.song}</span>
                          <span className="artist-name"> – {current.artist}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "10px", width: "98%" }}>
                          <span className="time">{formatTime(currentTime)}</span>

                          <input
                            className="timeline"
                            type="range"
                            min="0"
                            max={duration || 0}
                            value={currentTime}
                            onChange={(e) => {
                              const t = Number(e.target.value);
                              audioRef.current.currentTime = t;
                              setCurrentTime(t);
                            }}
                            style={{ flex: 1 }}
                          />
                          <span className="time">{formatTime(duration)}</span>
                        </div>
                            <img
                              className="media-button"
                              src={isPlaying ? "pause-icon.png" : "play-icon.png"}
                              alt="Play/Pause"
                              style={{filter: "brightness(0) sepia(1) saturate(3) hue-rotate(330deg)"}}
                              onClick={() => {
                              if (!audioRef.current) return;
                              isPlaying ? audioRef.current.pause() : audioRef.current.play();
                              setIsPlaying(!isPlaying);
                            }}
                            />
                      </div>
                    );
                  })()}
                </MediaPlayer>
                )}
                </div>
              </div>
            )}
            {
              <div className="around-media">
                {!view && !viewVideo && !showMusic && (
                  <div>
                    {itemsProp.map((img, index, array) => (
                      <span key={index} className="item">
                        <StyledUl>
                          <div>
                            {img.mimetype == "image/png" && (
                              <Picture1
                                key={index}
                                src={`https://ellinornielsen-backend.onrender.com/api/uploads/${img["filename"]}`}
                                alt={`https://ellinornielsen-backend.onrender.com/api/uploads/${img["filename"]}`}
                                onClick={() =>
                                  setView(
                                    `https://ellinornielsen-backend.onrender.com/api/uploads/${img["filename"]}`
                                  ) +
                                  window.scrollTo(0, 0) +
                                  getTextForPicture(img)
                                }
                              />
                            )}

                            {img.text && img.mimetype == "image/png" && (
                              <p className="image-text">{img.text}</p>
                            )}

                            {img.mimetype == "image/jpeg" && (
                              <Picture1
                                key={index}
                                src={`https://ellinornielsen-backend.onrender.com/api/uploads/${img["filename"]}`}
                                alt={`https://ellinornielsen-backend.onrender.com/api/uploads/${img["filename"]}`}
                                onClick={() =>
                                  setView(
                                    `https://ellinornielsen-backend.onrender.com/api/uploads/${img["filename"]}`
                                  ) +
                                  window.scrollTo(0, 0) +
                                  getTextForPicture(img)
                                }
                              />
                            )}
                            {img.text && img.mimetype == "image/jpeg" && (
                              <p className="image-text">{img.text}</p>
                            )}
                          </div>

                          {img.mimetype == "video/mp4" && (
                            <div>
                              <Video
                                ref={(el) => (videoRefs.current[index] = el)}
                                crossOrigin="anonymous"
                                width={
                                  focusedIndex === index
                                    ? isMobile
                                      ? "500px"
                                      : "400px"
                                    : "300px"
                                }
                                height={
                                  focusedIndex === index
                                    ? isMobile
                                      ? "500px"
                                      : "400px"
                                    : "300px"
                                }
                                muted={false}
                                style={{
                                  zIndex: 2,
                                  transition: "all 0.3s ease",
                                  transform:
                                    focusedIndex === index
                                      ? isMobile
                                        ? "scale(1.25)"
                                        : "scale(1.1)"
                                      : "scale(1)",
                                  marginBottom:
                                    focusedIndex === index
                                      ? isMobile
                                        ? "100px"
                                        : "50px"
                                      : "20px",
                                }}
                                controls
                                onPlay={() => handleVideoClick(index)}
                                onPause={() => {
                                  if (focusedIndex === index) {
                                    setFocusedIndex(null);
                                  }
                                }}
                                poster={img.poster}
                              >
                                <source
                                  src={`https://ellinornielsen-backend.onrender.com/api/uploads/${img["filename"]}`}
                                  type="video/mp4"
                                />
                              </Video>

                              {img.text && img.mimetype == "video/mp4" && (
                                <p
                                  className="video-text"
                                  style={{
                                    marginTop: focusedIndex === index
                                      ? isMobile ? "50px" : "28px"
                                      : "4px",
                                  }}
                                >{img.text}</p>
                              )}
                            </div>
                          )}
                        </StyledUl>
                      </span>
                    ))}
                  </div>
                )}
              </div>
            }
      </Container2>
      {!isMobile && (
        <Jumping>
          <div className="bosse animate__animated animate__bounceInDown animate__infinite">
            <h3> {showCitat}</h3>
          </div>
        </Jumping>
      )}
    </Total>
  );
}
export default Spelningar;

const Jumping = styled.div`
  bottom: 80px;
  position: fixed;
  right: 30px;
  display: grid;
  place-content: center;
  z-index: 99;
  @media screen and (max-width: 391px) {
    margin-left: 980px;
  }

  h3 {
    display: grid;
    place-content: center;
    border-radius: 32px;
    height: 120%;
    max-height: 500px;
    width: 15em;
    background-color: white;
    opacity: 0.5;
    color: black;
    padding: 20px;
  }
  div {
    animation-duration: 20s;
  }
`;

const Total = styled.div`
  .music-panel {
    display: inline-flex;
    flex-direction: column;
    position: relative;
    top: calc(5vh - 100px);

    @media screen and (min-width: 1800px) {
      top: 5%;
      left: 5%;
    }

    @media screen and (max-width: 1000px) {
      margin-left: 8.5vw !important;
      margin-top: 3px !important;
      top: 0;
      width: 80vw;
    }
  }

  .song-options {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr auto;
    width: 100%;
    background: rgba(248, 243, 238, 0.95);
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 -2px 20px rgba(129, 86, 65, 0.12);
  }

  .button-close {
    background: none;
    border: none;
    border-left: 1px solid rgba(193, 155, 120, 0.35);
    height: 44px;
    width: 52px;
    color: #815641;
    font-size: 15px;
    cursor: pointer;
    opacity: 0.55;
    transition: opacity 0.2s, background 0.2s;
    font-family: 'Jost', sans-serif;
    position: static;
    margin-left: 0;
    z-index: 999;

    &:hover {
      opacity: 1;
      background: rgba(129, 86, 65, 0.07);
    }

    @media screen and (max-width: 1000px) {
      width: 70px;
      height: 60px;
      font-size: 18px;
    }
  }

  .button-begravning {
    background: transparent;
    border: none;
    border-right: 1px solid rgba(193, 155, 120, 0.3);
    height: 44px;
    width: 314px;
    color: #815641;
    font-family: 'Cormorant Garamond', serif;
    font-size: 18px;
    font-style: italic;
    letter-spacing: 0.06em;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    z-index: 999;
    &:hover { background: rgba(129, 86, 65, 0.07); }
    @media screen and (max-width: 1800px) { width: 250px; }
    @media screen and (max-width: 1000px) { width: 240px; height: 60px; font-size: 22px; }
  }

  .button-begravning-active {
    background: #815641;
    border: none;
    border-right: 1px solid rgba(193, 155, 120, 0.3);
    height: 44px;
    width: 314px;
    color: #f8f3ee;
    font-family: 'Cormorant Garamond', serif;
    font-size: 18px;
    font-style: italic;
    letter-spacing: 0.06em;
    cursor: pointer;
    z-index: 999;
    @media screen and (max-width: 1800px) { width: 250px; }
    @media screen and (max-width: 1000px) { width: 240px; height: 60px; font-size: 22px; }
  }

  .button-dop {
    background: transparent;
    border: none;
    border-right: 1px solid rgba(193, 155, 120, 0.3);
    height: 44px;
    width: 314px;
    color: #815641;
    font-family: 'Cormorant Garamond', serif;
    font-size: 18px;
    font-style: italic;
    letter-spacing: 0.06em;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    z-index: 999;
    &:hover { background: rgba(129, 86, 65, 0.07); }
    @media screen and (max-width: 1800px) { width: 250px; }
    @media screen and (max-width: 1000px) { height: 60px; width: 240px; font-size: 22px; }
  }

  .button-dop-active {
    background: #815641;
    border: none;
    border-right: 1px solid rgba(193, 155, 120, 0.3);
    height: 44px;
    width: 314px;
    color: #f8f3ee;
    font-family: 'Cormorant Garamond', serif;
    font-size: 18px;
    font-style: italic;
    letter-spacing: 0.06em;
    cursor: pointer;
    z-index: 999;
    @media screen and (max-width: 1800px) { width: 250px; }
    @media screen and (max-width: 1000px) { height: 60px; width: 240px; font-size: 22px; }
  }

  .button-bröllop {
    background: transparent;
    border: none;
    border-right: 1px solid rgba(193, 155, 120, 0.3);
    height: 44px;
    width: 314px;
    color: #815641;
    font-family: 'Cormorant Garamond', serif;
    font-size: 18px;
    font-style: italic;
    letter-spacing: 0.06em;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    border-top-left-radius: 12px;
    z-index: 999;
    &:hover { background: rgba(129, 86, 65, 0.07); }
    @media screen and (max-width: 1800px) { width: 240px; }
    @media screen and (max-width: 1000px) { height: 60px; width: 240px; font-size: 22px; }
  }

  .button-bröllop-active {
    background: #815641;
    border: none;
    border-right: 1px solid rgba(193, 155, 120, 0.3);
    height: 44px;
    width: 314px;
    color: #f8f3ee;
    font-family: 'Cormorant Garamond', serif;
    font-size: 18px;
    font-style: italic;
    letter-spacing: 0.06em;
    cursor: pointer;
    border-top-left-radius: 12px;
    z-index: 999;
    @media screen and (max-width: 1800px) { width: 240px; }
    @media screen and (max-width: 1000px) { height: 60px; width: 240px; font-size: 22px; }
  }

  .category {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr auto;
    margin-left: 29.9vw;
    top: -17vh;
    position: relative;
    width: 48vw;
    background: rgba(248, 243, 238, 0.95);
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 -2px 20px rgba(129, 86, 65, 0.12);

    @media screen and (max-width: 1000px) {
      top: 30px !important;
      margin-left: 2vw;
      width: 96vw;
    }

    @media screen and (max-width: 1800px) {
      top: -35vh;
      margin-left: 20vw;
      width: 60vw;
    }

    button {
      background: transparent;
      border: none;
      border-right: 1px solid rgba(193, 155, 120, 0.3);
      height: 44px;
      color: #815641;
      font-family: 'Cormorant Garamond', serif;
      font-size: 18px;
      font-style: italic;
      letter-spacing: 0.06em;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;
      &:hover { background: rgba(129, 86, 65, 0.07); }
      @media screen and (max-width: 1000px) { height: 60px; font-size: 22px; }
    }

    .bröllop-button-active,
    .dop-button-active,
    .begravning-button-active {
      background: #815641;
      color: #f8f3ee;
      &:hover { background: #815641; }
    }

    .closeButton {
      width: 52px;
      border-right: none;
      border-left: 1px solid rgba(193, 155, 120, 0.35);
      border-radius: 0;
      opacity: 0.55;
      font-style: normal;
      font-size: 15px;
      transition: opacity 0.2s, background 0.2s;
      &:hover { opacity: 1; background: rgba(129, 86, 65, 0.07); }
      @media screen and (max-width: 1000px) { width: 70px; font-size: 18px; }
    }
  }

  .laddaUpp {
    width: 150px;
    height: 40px;
    font-size: 22px;
    border-radius: 4px;
    border-left: 2px solid black;
    background-color: rgba(162, 97, 23, 1);
    color: white;
    font-family: "helvetica";
    position: absolute;
    right: 10px;
    top: 120px;

    @media screen and (max-width: 1000px) {
      width: 220px;
      height: 60px;
      top: 100px;
    }
  }

  .LaddaOm {
    width: 150px;
    height: 40px;
    font-size: 22px;
    border-radius: 4px;
    border-left: 2px solid black;
    background-color: rgba(162, 97, 23, 1);
    color: white;
    font-family: "helvetica";
    position: absolute;
    right: 10px;
    top: 165px;
    @media screen and (max-width: 1000px) {
      width: 220px;
      height: 60px;
      margin-bottom: 1000px;
      top: 160px;
    }
  }

  .citatLista {
    width: 150px;
    height: 40px;
    font-size: 22px;
    border-radius: 4px;
    border-left: 2px solid black;
    background-color: rgba(162, 97, 23, 1);
    color: white;
    font-family: "helvetica";
    position: absolute;
    right: 10px;
    top: 210px;
    @media screen and (max-width: 1000px) {
      width: 220px;
      height: 60px;
      margin-bottom: 10px;
      top: 220px;
    }
  }

  .låtLista {
    width: 150px;
    height: 40px;
    font-size: 22px;
    border-radius: 4px;
    border-left: 2px solid black;
    background-color: rgba(162, 97, 23, 1);
    color: white;
    font-family: "helvetica";
    position: absolute;
    right: 10px;
    top: 255px;
    @media screen and (max-width: 1000px) {
      width: 220px;
      height: 60px;
      margin-bottom: 10px;
      top: 280px;
    }
  }
`;
const JumpingSecond = styled.div`
  position: relative;
  display: grid;
  place-content: center;

  .text {
    color: white;
    margin-top: 60vh;
    margin-left: 50%;
    font-family: "Brush Script MT, Brush Script Std, cursive";
    font-style: italic;
    @media screen and (max-width: 1000px) {
      margin-left: 40vw;
      font-size: 100px;
      margin-top: 40vh;
    }
  }
  .bosse {
    background-color: black;
    height: 3000px;
    width: 3000px;
    margin-top: -400px;
    animation-duration: 15s;
    @media screen and (max-width: 1000px) {
      height: 200vh;
      width: 120vw;
    }
  }
`;

const Picture1 = styled.img`
  width: 300px;
  height: 300px;
  border-radius: 12px;
  box-shadow: 0 0 50px gray;
  background-color: white;
  position: relative;
  object-fit: contain;

  @media screen and (max-width: 1000px) {
  }

  :hover {
    transition: 1s;
    height: 400px;
    width: 600px;
  }

  :not(:hover) {
    transition: 1s;
    height: 400px;
    width: 600px;
  }
`;

const Picture1LoggedIn = styled.img`
  width: 300px;
  height: 300px;
  border-radius: 12px;
  box-shadow: 0 0 50px gray;
  background-color: white;
  position: relative;
  object-fit: contain;

  :hover {
    transition: 1s;
    height: 400px;
    width: 600px;
    @media screen and (max-width: 1000px) {
      height: 250px;
      width: 450px;
    }
  }

  :not(:hover) {
    transition: 1s;
    height: 400px;
    width: 600px;
    @media screen and (max-width: 1000px) {
      height: 250px;
      width: 450px;
    }
  }
`;

const Video = styled.video`
  width: 300px;
  height: 300px;
  border-radius: 12px;
  box-shadow: 0 0 50px gray;
  background-color: white;
  position: relative;
  object-fit: contain;

  @media screen and (max-width: 1000px) {
  }

  :hover {
    transition: 1s;
    height: 400px;
    width: 600px;
  }
  :not(:hover) {
    transition: 1s;
    height: 400px;
    width: 600px;
  }
`;

const VideoLoggedIn = styled.video`
  width: 300px;
  height: 300px;
  border-radius: 12px;
  box-shadow: 0 0 50px gray;
  background-color: white;
  position: relative;
  object-fit: contain;
  .item:last-child {
    img {
      margin-bottom: 500px !important;
    }
  }

  :hover {
    transition: 1s;
    height: 420px;
    width: 600px;
    @media screen and (max-width: 1000px) {
      height: 250px;
      width: 450px;
    }
  }
  :not(:hover) {
    transition: 1s;
    height: 400px;
    width: 600px;
    @media screen and (max-width: 1000px) {
      height: 250px;
      width: 450px;
    }
  }
`;

const Container = styled.div`
  height: 200px;
  display: grid;
  margin-right: 100px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  position: relative;

  .all-items:last-child {
    .item {
      margin-bottom: 500px !important;
    }
  }

  .remove-list {
    border: 2px solid black;
    font-size: 32px;
    color: red;
    text-align: center;
  }

  @media screen and (max-width: 1000px) {
    margin-left: 80px;
  }
`;

const Container2 = styled.div`
  height: 200px;
  display: grid;
  /* margin-right: 100px; */
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  z-index: 97;
  margin-top: -15%;

  .around-media {
    @media screen and (min-width: 1800px) {
      margin-left: 11%;
    }
  }

  .item:last-child {
    p {
      margin-bottom: 500px;
    }
  }

  @media screen and (max-width: 1000px) {
    margin-left: -3%;
    margin-top: 2px;
  }

  img {
    margin: 30px;
  }
  video {
    margin: 30px;
  }

  .playButton {
    z-index: 999;
    position: absolute;
    margin-left: 9vw;
    margin-top: 15vh;
    height: 100px;
    width: 100px;
    opacity: 1;
    -webkit-filter: hue-rotate(45deg);
    filter: hue-rotate(47deg);
    @media screen and (max-width: 1000px) {
      margin-top: 7vh;
      margin-left: 14vw;
    }
  }
`;

const StyledUl = styled.ul`
  /* height: 200px;
  width: 100px; */

  position: relative;

  .video-text {
    font-family: 'Cormorant Garamond', serif;
    font-style: italic;
    font-size: 15px;
    color: #815641;
    letter-spacing: 0.05em;
    border-top: 1px solid rgba(193, 155, 120, 0.45);
    padding: 7px 8px 0;
    margin-left: 30px;
    margin-bottom: 100px;
    max-width: 580px;
    width: 580px;
    transition: margin-top 0.3s ease;

    @media screen and (max-width: 1000px) {
      font-size: 20px;
      max-width: 80vw;
    }
  }

  .image-text {
    font-family: 'Cormorant Garamond', serif;
    font-style: italic;
    font-size: 15px;
    color: #815641;
    letter-spacing: 0.05em;
    border-top: 1px solid rgba(193, 155, 120, 0.45);
    padding: 7px 8px 0;
    margin-top: 4px;
    margin-left: 30px;
    margin-bottom: 100px;
    max-width: 580px;
    width: 580px;

    @media screen and (max-width: 1000px) {
      font-size: 20px;
      max-width: 80vw;
    }
  }

  @media screen and (max-width: 1000px) {
    video::-webkit-media-controls {
      zoom: 1.5;
    }
  }
`;

const Social = styled.div`
  z-index: 98;
  @media screen and (max-width: 1000px) {
  }

  .link {
    text-decoration: none;
    position: relative;
    max-width: 200px;
    margin-left: 20px;
  }
  text-decoration: none;
  body {
    width: 100vw;
    background-color: #1d1d1d;
    margin: 0;
    font-family: helvetica;
  }

  .about {
    $cubic: cubic-bezier(0.64, 0.01, 0.07, 1.65);
    $transition: 0.6s $cubic;
    $size: 40px;
    position: fixed;
    z-index: 10;
    bottom: 10px;
    right: 10px;
    width: $size;
    height: $size;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    transition: all 0.2s ease;

    .bg_links {
      width: $size;
      height: $size;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(#fff, 0.2);
      border-radius: 100%;
      backdrop-filter: blur(5px);
      position: absolute;
    }

    .logo {
      width: $size;
      height: $size;
      z-index: 9;
      background-image: url(https://rafaelalucas91.github.io/assets/codepen/logo_white.svg);
      background-size: 50%;
      background-repeat: no-repeat;
      background-position: 10px 7px;
      opacity: 0.9;
      transition: all 1s 0.2s ease;
      bottom: 0;
      right: 0;
    }

    .social {
      opacity: 0;
      right: 0;
      bottom: 0;

      .icon {
        width: 100%;
        height: 100%;
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-color: transparent;
        display: flex;
        transition: all 0.2s ease, background-color 0.4s ease;
        opacity: 0;
        border-radius: 100%;
      }

      &.portfolio {
        transition: all 0.8s ease;

        .icon {
          background-image: url(https://rafaelalucas91.github.io/assets/codepen/link.svg);
        }
      }

      &.dribbble {
        transition: all 0.3s ease;
        .icon {
          background-image: url(https://rafaelalucas91.github.io/assets/codepen/dribbble.svg);
        }
      }

      &.linkedin {
        transition: all 0.8s ease;
        .icon {
          background-image: url(https://rafaelalucas91.github.io/assets/codepen/linkedin.svg);
        }
      }
    }

    &:hover {
      width: 105px;
      height: 105px;
      transition: all $transition;

      .logo {
        opacity: 1;
        transition: all 0.6s ease;
      }

      .social {
        opacity: 1;

        .icon {
          opacity: 0.9;
        }

        &:hover {
          background-size: 28px;
          .icon {
            background-size: 65%;
            opacity: 1;
          }
        }

        &.portfolio {
          right: 0;
          bottom: calc(100% - 40px);
          transition: all 0.3s 0s $cubic;

          .icon {
            &:hover {
              background-color: #698fb7;
            }
          }
        }

        &.dribbble {
          bottom: 45%;
          right: 45%;
          transition: all 0.3s 0.15s $cubic;
          .icon {
            &:hover {
              background-color: #ea4c89;
            }
          }
        }

        &.linkedin {
          bottom: 0;
          right: calc(100% - 40px);
          transition: all 0.3s 0.25s $cubic;
          .icon {
            &:hover {
              background-color: #0077b5;
            }
          }
        }
      }
    }
  }

  .wrapper {
    width: 100vw;
    margin: 0 auto;
    background-color: #161616;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all 0.3s ease;
  }

  @media screen and (max-width: 767px) {
    .wrapper {
      height: 700px;
    }
  }

  .content {
    width: 100vw;
    height: 30%;
    padding: 0 4%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    bottom: -5%;
    position: fixed;
    @media screen and (max-width: 1000px) {
      left: -24%;
      height: 20%;
    }

    @media screen and (max-width: 1800px) {
      left: -5%;
    }
  }

  @media screen and (max-width: 767px) {
    .content {
      /* padding-top: 300px;
      flex-direction: column; */
    }
  }

  .card {
    width: 50%;
    max-width: 300px;
    min-width: 200px;
    height: 150px;
    background-color: #815641;
    margin: 10px;
    border-radius: 10px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
    border: 2px solid rgba(7, 7, 7, 0.12);
    font-size: 12px;
    transition: all 0.3s ease;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .mic {
      margin-left: -200px;
      margin-top: -90px;
      height: 80px;
      width: 80px;
      position: relative;
    }

    cursor: pointer;
    transition: all 0.3s ease;
    :hover {
      margin-top: -120px;
    }
  }

  .icon {
  }

  .material-icons.md-18 {
    font-size: 12px;
  }
  .material-icons.md-24 {
    font-size: 12px;
  }
  .material-icons.md-36 {
    font-size: 28px;
  }
  .material-icons.md-48 {
    font-size: 48px;
  }

  .card .title {
    width: 100%;
    margin: 0;
    text-align: center;
    margin-top: -40px;
    color: white;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 4px;
    font-size: 20px;
    font-family: helvetica !important;
  }

  .card .text {
    width: 80%;
    margin: 0 auto;
    font-size: 12px;
    text-align: center;
    margin-top: 20px;
    color: white;
    font-weight: 200;
    letter-spacing: 2px;
    opacity: 0;
    max-height: 0;
  }

  .card:hover {
    height: 270px;
  }

  .card:hover .info {
    height: 90%;
  }
  .card:hover .info {
    height: 90%;
  }

  .card:hover .text {
    opacity: 1;
    max-height: 40px;
    margin-top: 0px;
    font-size: 15px;
  }

  .card:hover .icon {
    background-position: -120px;
    margin-top: -40px;
    height: 150px;
  }

  .card:hover .title {
    margin-top: -200px;
    margin-bottom: 60px;
  }

  .card:hover .icon i {
    background: linear-gradient(90deg, #ff7e7e, #ff4848);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    opacity: 1;
  }
`;

const Selected = styled.div`
  position: relative;
  height: 700px;
  width: 700px;
  left: 5%;
  top: -15%;
  margin-right: 50vw;
  margin-left: 20%;
  img {
    height: 100%;
    width: 100%;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  }
  video {
    margin-top: -8%;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
    @media screen and (max-width: 1000px) {
      width: 70vw;
      height: auto;
      max-width: none;
      max-height: 100vh;
      object-fit: contain;
      margin-top: -17vh;
      margin-left: 49%;
    }
  }
  p {
    margin-top: -2vh;
    margin-left: 2vw;
    width: 800px;
    max-height: 200px;
    overflow: auto;
    background-color: #ffffff76;
    color: black;
    @media screen and (max-width: 1000px) {
      margin-left: 12vw;
      margin-top: 0vh;
      width: 800px;
      font-size: 32px;
    }

    ::-webkit-scrollbar {
      width: 1em;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    ::-webkit-scrollbar-thumb {
      background-color: rgba(162, 97, 23, 1);
      outline: 1px solid slategrey;
    }
  }

  button {
    position: absolute;
    margin-left: 112%;
    margin-top: -10%;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    background-color: #a26117;
    border: 0px;
    color: white;
    z-index: 999;
    @media screen and (max-width: 1000px) {
      margin-top: -19vh;
      font-size: 30px;
      height: 80px;
      width: 80px;
      margin-left: 85vw;
    }
  }

  @media screen and (max-width: 1000px) {
    width: 40vw;
    height: 40vh;
    max-width: none;
    max-height: 2vh !important;
    object-fit: contain;
    margin-top: 15vh;
    margin-left: -10%;
  }
`;

const Selected2 = styled.div`
  position: relative;
  max-height: 800px;
  width: 800px;
  aspect-ratio: 0.0001;
  left: 5%;
  top: -10%;
  margin-right: 50vw;
  margin-left: 20%;
  margin-bottom: 200px;
  @media screen and (max-width: 1000px) {
    margin-left: 0%;
    height: 100vh;
    width: 100vw;
    top: -7%;
  }
  img {
    height: 100%;
    width: 100%;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
    object-fit: contain;

    @media screen and (max-width: 1000px) {
      height: 100%;
      width: 100%;
      margin-left: 6vw;
      margin-top: -20vh;
    }
  }
  video {
    margin-top: -8%;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  }

  button {
    position: absolute;
    margin-left: 100%;
    margin-top: 1%;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: rgba(162, 97, 23, 1);
    border: 0px;
    color: white;
    z-index: 999;
    @media screen and (max-width: 1000px) {
      font-size: 30px;
      margin-left: 100%;
      margin-top: -23vh;
      height: 100px;
      width: 100px;
    }
  }

  @media screen and (max-width: 1000px) {
    width: 100vw;
    height: 75vh;
    max-width: none;
    max-height: 100vh;
    object-fit: contain;
    margin-top: 30vh;
    margin-left: -5%;
  }
`;

const Sidemenu = styled.div`
  z-index: 99;
  position: fixed;
  margin: 0;
  padding: 0;
  border: 0;
  width: 20%;
  height: 100%;
  font-family: Helvetica;
  color: rgb(79, 41, 6);
  margin-top: -20%;

  @media screen and (max-width: 1000px) {
    display: none;
  }

  @media screen and (max-width: 1800px) {
    margin-top: -20%;
  }

  .menu {
    backdrop-filter: blur(19.5px);
    -webkit-backdrop-filter: blur(19.5px);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    opacity: 0.8;
    border-radius: 32px;
    padding: 0 10px 0 10px;
    margin-top: 13%;
    width: 280px;
    top: 55%;
    left: 2%;
    position: absolute;
    font-family: helvetica;
    color: #3d3535;
    font-size: 22px;

    .låtförslag {
      height: 34px;
      width: auto;
      padding: 0 18px;
      border: 1px solid #815641;
      border-radius: 17px;
      background: transparent;
      color: #815641;
      font-family: 'Cormorant Garamond', serif;
      font-style: italic;
      font-size: 16px;
      letter-spacing: 0.06em;
      cursor: pointer;
      margin-left: 8px;
      transition: background 0.25s, color 0.25s;
      vertical-align: middle;

      &:hover {
        background: #815641;
        color: #f8f3ee;
      }
    }
  }
`;

const SideMenuMobile = styled.div`
  z-index: 99;
  position: fixed;
  margin: 0;
  padding: 0;
  border: 0;
  width: 20%;
  height: 100%;
  font-family: Helvetica;
  color: rgb(79, 41, 6);
  margin-top: 11%;

  button {
    background-color: #815641 !important;
    color: white !important;
    width: 400px;
    height: 60px;
    rotate: calc(-90deg);
    position: absolute;
    right: -60px;
    top: 30vh;
    border-bottom-left-radius: 100%;
    border-bottom-right-radius: 100%;
    font-size: 32px;
    font-family: Helvetica;
  }

  .menu {
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    backdrop-filter: blur(19.5px);
    -webkit-backdrop-filter: blur(19.5px);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    opacity: 0.8;
    border-radius: 32px;
    padding: 20px;
    margin-top: 13%;
    width: 350px;
    top: 55%;
    left: 2%;
    position: absolute;
    font-family: helvetica;
    color: #3d3535;
    font-size: 22px;
    /* 
    .låtförslag {
      height: 40px;
      width: 70px;
      border: 2px;
      border-radius: 8px;
      background-color: #815641;
      color: white;
      margin-left: 25px;
      font-family: "helvetica";
      margin-left: 10px;
    } */
  }
`;

const LåtLista = styled.div`
  z-index: 100;
  width: 100%;
  height: 50vh;
  overflow: auto;
  overflow-x: hidden;
  background: rgba(248, 243, 238, 0.94);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(193, 155, 120, 0.28);
  border-top: none;
  box-shadow: 0 8px 32px rgba(129, 86, 65, 0.1);

  .artist {
    font-size: 13px;
    font-family: 'Jost', sans-serif;
    color: #815641;
    margin-top: 0;
    margin-bottom: 4px;
    letter-spacing: 0.04em;
    @media screen and (max-width: 1000px) { font-size: 18px; }
  }

  .låt {
    margin-top: 10px;
    margin-bottom: 2px;
    font-family: 'Cormorant Garamond', serif;
    font-size: 20px;
    color: #120d09;
    letter-spacing: 0.02em;
    @media screen and (max-width: 1000px) { font-size: 28px; }
  }

  @media screen and (max-width: 1000px) {
    height: 40lvh;
    width: 100%;
  }

  .list-container {
    display: grid;
    grid-template-columns: 9fr 1fr;
    border-bottom: 1px solid rgba(193, 155, 120, 0.3);
    transition: background 0.18s;
    &:hover { background: rgba(129, 86, 65, 0.05); }
  }

  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb {
    background: rgba(129, 86, 65, 0.35);
    border-radius: 2px;
  }

  p {
    margin-left: 20px;
    font-family: 'Cormorant Garamond', serif;
    font-size: 20px;
    @media screen and (max-width: 1000px) { height: 50px; }
  }

  .list-button {
    height: 26px;
    width: 26px;
    margin-top: 14px;
    opacity: 0.65;
    transition: opacity 0.2s, transform 0.15s;
    &:hover { opacity: 1; transform: scale(1.1); }
    @media screen and (max-width: 1000px) {
      height: 46px;
      width: 46px;
      margin-top: 18px;
    }
  }
`;

const MediaPlayer = styled.div`
  width: 100%;
  background: rgba(248, 243, 238, 0.97);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-radius: 0 0 12px 12px;
  border: 1px solid rgba(193, 155, 120, 0.28);
  border-top: none;
  padding: 12px 18px 16px;
  box-shadow: 0 8px 28px rgba(129, 86, 65, 0.12);
  box-sizing: border-box;

  .text {
    font-family: 'Cormorant Garamond', serif;
    font-size: 16px;
    margin: 0 0 8px 2px;
    letter-spacing: 0.03em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (max-width: 1000px) { font-size: 22px; }
  }

  .song-name {
    color: #120d09;
    font-weight: 600;
  }

  .artist-name {
    color: #815641;
    font-weight: 400;
    font-style: italic;
  }

  .media-button {
    display: block;
    margin: 10px auto 0;
    border: none;
    background: none;
    cursor: pointer;
    width: 32px;
    height: 32px;
    filter: brightness(0) sepia(1) saturate(3) hue-rotate(330deg) !important;
    opacity: 0.8;
    transition: opacity 0.2s, transform 0.15s;
    &:hover { opacity: 1; transform: scale(1.12); }
    @media screen and (max-width: 1000px) { width: 46px; height: 46px; }
  }

  .time {
    font-size: 11px;
    font-family: 'Jost', sans-serif;
    color: #b08060;
    min-width: 34px;
    @media screen and (max-width: 1000px) { font-size: 20px; }
  }

  .timeline {
    -webkit-appearance: none;
    appearance: none;
    flex: 1;
    height: 3px;
    border-radius: 4px;
    background: rgba(193, 155, 120, 0.3);
    cursor: pointer;
  }

  .timeline::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #815641;
    cursor: pointer;
  }

  .timeline::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #815641;
    border: none;
    cursor: pointer;
  }

  .timeline::-ms-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #815641;
    border: none;
    cursor: pointer;
  }
`
